export default {"src":"/_next/static/media/Paris.522ffe15.svg","height":72,"width":64};